<template>   
    <v-card>
        <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>

        <v-card-text>
            <h3>My study groups</h3>
            <br>
            <div>
                <v-chip v-for="(group, index) in content" :key="index" close @click:close="tryLeaveGroup(group)">{{group.group_name}}                                        
                </v-chip>
            </div>
            <br>
            <v-card v-if="new_group">
                <v-card-title>Select group<v-icon class="btn-close" @click="new_group = false"> close</v-icon> </v-card-title>
                <v-card-text>
                    <v-autocomplete @input="tryToAddToGroups()"
                                                v-model="groups2"
                                                :items="student_groups"
                                                :search-input.sync="search2"
                                                hide-selected
                                                label="Add groups"
                                                multiple
                                                small-chips
                                            ></v-autocomplete>

                </v-card-text>
            </v-card>
                <br>
            <v-row justify="center">
                <v-icon @click="prepareStudyGroups()">mdi-plus-circle-outline</v-icon>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                    'getShowModalMessageResult'                    
                ])
    ,
    data() {
        return {
            content : null,
            groups2: [],
            student_groups: [],
            student_groups_full: [],
            search2: null,
            addingGroup: null,
            deleteGroup: null,
            new_group: false
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    

            // get category list
            axios.get('/get-student-course-groups/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.content = res.data.groups                    
                    if (res.data.message != 'OK') {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id }, //#                   
                        { text: res.data.course.name, href: '/course_content/' + res.data.course.id }, //#
                        { text: "My course settings", href: '/student_settings/' + res.data.course.id }, //#
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        prepareStudyGroups() {
            this.new_group = true
            axios.get('/get-all-student-course-groups/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    console.log(res.data)
                    this.student_groups = []
                    this.student_groups_full = []
                    res.data.groups.forEach(el => { 
                        if (!this.isInGroup(el.id)) {
                            this.student_groups.push(el.group_name)
                            this.student_groups_full.push({id: el.id, group_name: el.group_name, })
                        }
                    });
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })      
        },
        isInGroup(_id) {
            for(let i=0; i<this.content.length; i++) {
                if ( this.content[i].id == _id) return true
            }               
            return false
        },       
        tryToAddToGroups() {
            const _group_name = this.groups2[0]
            this.groups2 = []

            // if it is in my group - away - probably never
            for(let i=0; i<this.content.length; i++) {
                if (this.content[i].group_name == _group_name) {
                    const _index = this.student_groups.indexOf(_group_name)
                    this.student_groups_full.splice(_index,1)
                    this.student_groups.splice(_index,1)
                    return
                }
            }

            this.addingGroup = null
            for(let i=0; i<this.student_groups_full.length; i++) {
                if (this.student_groups_full[i].group_name == _group_name) {
                    this.addingGroup = {
                        id : this.student_groups_full[i].id,
                        group_name: this.student_groups_full[i].group_name
                    }
                }
            }

            if (this.addingGroup == null) return
            this.$store.commit('setShowModalMessage',
                            {content: 'Enter the key to join the group "'+_group_name+'".', type: 'warning', 
                             buttons:[], icons:[{text:'close', color:'red', value: 9},{text:'done', color:'green', value: 10}], input: 1})
        },
        addToNewGroup(_group, _key) {
            const _data = {
                group_id: _group.id,
                group_key: _key,
                course_id: this.$route.params.id
            }
            axios.post('/add-student-to-course-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    for(let i=0; i<this.student_groups_full.length; i++) {
                        if (this.student_groups_full[i].id == _group.id) {
                            this.student_groups_full.splice(i,1)
                            this.student_groups.splice(i,1)
                            break;
                        }
                    }

                    // add to teaching list
                    this.content.push({
                            id: _group.id,
                            group_name: _group.group_name,
                    })
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        processModalResult() {
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) {
                this.leaveStudyGroup(this.deleteGroup)
            }
            if (res == 10) {
               this.addToNewGroup(this.addingGroup, this.$store.getters.getShowModalMessageText)
            }
        },
        tryLeaveGroup(_group) {
            this.deleteGroup = _group
            this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>Do you want to leave the group "' + _group.group_name + '"?', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})

        },
        leaveStudyGroup(_group) {
            const _data = {
                group_id : _group.id,
                course_id: this.$route.params.id
            }
            axios.post('/leave-course-group', _data, this.$store.getters.getAxiosConfig)
            .then(res => {                   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }  else {
                    this.initData()
                }                                        
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })            
        }

    }
}
</script>